import React from "react";
import { RecoilRoot } from "recoil";
import MiddlewareDosen from "./middleware/Dosen";
import Routes from "./routes";

const App = () => {
  return (
    <RecoilRoot>
      <MiddlewareDosen>
        <Routes />
      </MiddlewareDosen>
    </RecoilRoot>
  );
};

export default App;
